import React, { useState } from "react";
import { PLANNER_STORAGE_KEY } from "./utils/constants";
import eventDispatch from "./utils/eventDispatch";
import {
    BASKET_DECREASED,
    BASKET_INCREASED,
    TOGGLE_BASKET,
} from "./utils/events";

export default ({ panel, showText, buttonClass, onRemove }) => {
    let addedPanels =
        JSON.parse(localStorage.getItem(PLANNER_STORAGE_KEY)) || [];
    const [inBasket, setInBasket] = useState(
        addedPanels.find((p) => p.id === panel.id)
    );

    const onAddOrRemove = () => {
        const addedInBasket = addOrRemoveItem(panel, onRemove);
        setInBasket(addedInBasket);

        eventDispatch(TOGGLE_BASKET, { panel, added: addedInBasket });
    };

    const dataAdd = () => {
        dataLayer.push({ event: "Campaign Click", panelId: panel.siteID });
    };

    return (
        <span className="panel__booking" onClick={dataAdd}>
            <button onClick={onAddOrRemove} className={buttonClass}>
                <span className="text">
                    {inBasket ? "Remove from campaign" : "Add to campaign"}
                </span>
                {inBasket ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                        <g fill="none" fill-rule="evenodd">
                            <circle
                                fill="#18A14A"
                                cx="25.5"
                                cy="25.5"
                                r="25.5"
                            />
                            <g fill="#FFF" fill-rule="nonzero">
                                <path d="M34.3424 11.2281h-.2122v-.753a1.482 1.482 0 0 0-.4323-1.0427 1.4747 1.4747 0 0 0-2.5178 1.0428v.753h-1.9714v-.753a1.4806 1.4806 0 0 0-.4322-1.0428 1.4747 1.4747 0 0 0-2.518 1.0428v.753h-1.9713v-.753a1.482 1.482 0 0 0-.4322-1.0428 1.4747 1.4747 0 0 0-2.518 1.0428v.753h-1.9712v-.753a1.482 1.482 0 0 0-.4323-1.0428 1.4747 1.4747 0 0 0-2.5179 1.0428v.753h-.2122c-1.7683.002-3.2013 1.435-3.2034 3.2033v23.365c.002 1.7684 1.435 3.2014 3.2034 3.2035h18.139c1.7683-.002 3.2013-1.435 3.2034-3.2034v-23.365c-.002-1.7684-1.435-3.2014-3.2034-3.2035Zm-1.9645-.753a.2772.2772 0 0 1 .2772-.2772.2718.2718 0 0 1 .1917.077.2899.2899 0 0 1 .0855.2003v2.5873a.2738.2738 0 0 1-.2772.2773.2776.2776 0 0 1-.2772-.2773v-2.5873Zm-4.9215 0a.2772.2772 0 0 1 .4689-.2001.2892.2892 0 0 1 .0856.2002v2.5873a.2738.2738 0 0 1-.2773.2773.2776.2776 0 0 1-.2772-.2773v-2.5873Zm-4.9215 0a.2772.2772 0 0 1 .2773-.2772.2708.2708 0 0 1 .1913.077.2885.2885 0 0 1 .0859.2003v2.5873a.2776.2776 0 0 1-.2772.2773.2739.2739 0 0 1-.2773-.2773v-2.5873Zm-4.9214 0a.2772.2772 0 0 1 .2772-.2772.2708.2708 0 0 1 .1913.077.2885.2885 0 0 1 .0859.2003v2.5873a.2776.2776 0 0 1-.2772.2773.2739.2739 0 0 1-.2772-.2773v-2.5873ZM36.348 37.7967c-.0014 1.107-.8985 2.0042-2.0056 2.0055h-18.139c-1.107-.0013-2.0042-.8984-2.0055-2.0055v-23.365c.0013-1.1072.8984-2.0043 2.0055-2.0056h.2122v.6365a1.475 1.475 0 1 0 2.9502 0v-.6365h1.9713v.6365c0 .8147.6604 1.4751 1.475 1.4751.8147 0 1.4751-.6604 1.4751-1.475v-.6366h1.9714v.6365a1.475 1.475 0 0 0 2.9501 0v-.6365h1.9714v.6365c0 .8147.6604 1.4751 1.475 1.4751.8147 0 1.4751-.6604 1.4751-1.475v-.6366h.2122c1.107.0013 2.0042.8984 2.0056 2.0055v23.365Z" />
                                <path d="M32.7715 17.7972H17.7743a.599.599 0 0 0 0 1.1978h14.9972a.599.599 0 0 0 0-1.1978ZM32.7715 22.9425H17.7743a.599.599 0 0 0 0 1.1978h14.9972a.599.599 0 0 0 0-1.1978ZM32.6551 28.0878H17.7743a.599.599 0 1 0 0 1.1978h14.8808a.599.599 0 1 0 0-1.1978ZM32.6551 33.2334H17.7743a.599.599 0 0 0 0 1.1979h14.8808a.599.599 0 1 0 0-1.1979Z" />
                            </g>
                            <circle
                                stroke="#FFF"
                                fill="#FFF"
                                cx="35.5"
                                cy="29.5"
                                r="7.5"
                            />
                            <path
                                fill="#18A14A"
                                fill-rule="nonzero"
                                d="M40.179 30.976v-1.708h-8.358v1.708z"
                            />
                        </g>
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                        <g fill="none" fill-rule="evenodd">
                            <circle fill="#FFF" cx="25.5" cy="25.5" r="25.5" />
                            <g fill="#000" fill-rule="nonzero">
                                <path d="M34.34 11.23h-.21v-.75a1.48 1.48 0 0 0-2.04-1.37c-.55.23-.91.77-.91 1.37v.75h-1.97v-.75a1.48 1.48 0 0 0-2.04-1.37c-.55.23-.91.77-.91 1.37v.75h-1.97v-.75a1.48 1.48 0 0 0-2.04-1.37c-.55.23-.91.77-.91 1.37v.75h-1.97v-.75a1.48 1.48 0 0 0-2.04-1.37c-.56.23-.91.77-.91 1.37v.75h-.22a3.2 3.2 0 0 0-3.2 3.2V37.8a3.2 3.2 0 0 0 3.2 3.2h18.14a3.2 3.2 0 0 0 3.2-3.2V14.43a3.2 3.2 0 0 0-3.2-3.2Zm-1.96-.75a.28.28 0 1 1 .55 0v2.58a.27.27 0 0 1-.27.28.28.28 0 0 1-.28-.28v-2.58Zm-4.92 0a.28.28 0 0 1 .55 0v2.58a.27.27 0 0 1-.28.28.28.28 0 0 1-.27-.28v-2.58Zm-4.93 0a.28.28 0 0 1 .56 0v2.58a.28.28 0 0 1-.56 0v-2.58Zm-4.92 0a.28.28 0 1 1 .56 0v2.58a.28.28 0 0 1-.56 0v-2.58ZM36.35 37.8a2 2 0 0 1-2 2H16.2a2 2 0 0 1-2-2V14.43c0-1.1.9-2 2-2h.22v.63a1.48 1.48 0 1 0 2.95 0v-.63h1.97v.63a1.48 1.48 0 0 0 2.95 0v-.63h1.97v.63a1.48 1.48 0 0 0 2.95 0v-.63h1.97v.63a1.48 1.48 0 1 0 2.95 0v-.63h.21a2 2 0 0 1 2 2V37.8Z" />
                                <path d="M32.77 17.8h-15a.6.6 0 0 0 0 1.2h15a.6.6 0 0 0 0-1.2ZM32.77 22.94h-15a.6.6 0 0 0 0 1.2h15a.6.6 0 0 0 0-1.2ZM32.66 28.09H17.77a.6.6 0 1 0 0 1.2h14.89a.6.6 0 1 0 0-1.2ZM32.66 33.23H17.77a.6.6 0 0 0 0 1.2h14.89a.6.6 0 1 0 0-1.2Z" />
                            </g>
                            <circle
                                fill="#18A14A"
                                cx="35.5"
                                cy="29.5"
                                r="7.5"
                            />
                            <path
                                fill="#FFF"
                                fill-rule="nonzero"
                                d="m34.78 32.65 1.46-.02v-2.27h2.26V28.9h-2.26v-2.27h-1.46v2.27H32.5v1.46h2.28z"
                            />
                        </g>
                    </svg>
                )}
            </button>
        </span>
    );
};

export const addOrRemoveItem = (panel, onRemove) => {
    let addedPanels =
        JSON.parse(localStorage.getItem(PLANNER_STORAGE_KEY)) || [];
    const found = addedPanels.find((p) => p.id === panel.id);
    let bRet;
    if (found) {
        addedPanels = addedPanels.filter((p) => p.id !== panel.id);
        bRet = false;
        if (onRemove) {
            onRemove();
        }
    } else {
        addedPanels.push(panel);
        bRet = true;
    }
    localStorage.setItem(PLANNER_STORAGE_KEY, JSON.stringify(addedPanels));

    if (bRet) {
        eventDispatch(BASKET_INCREASED);
    } else {
        eventDispatch(BASKET_DECREASED);
    }

    return bRet;
};

export const ADDED_PANELS =
    JSON.parse(localStorage.getItem(PLANNER_STORAGE_KEY)) || [];
